<template>
    <div>
        <el-form :model="shopProduct" ref="shopProductForm" :rules="rules" label-width="80px" size="mini" :inline="true">
            <el-form-item label="商品名称" prop="productName">
                <el-input :disabled="stateDisabled" style="width: 200px" size="small" v-model="shopProduct.productName"></el-input>
            </el-form-item>
            <el-form-item label="商品货号" prop="itemCode">
                <el-input :disabled="stateDisabled" style="width: 130px" size="small" v-model="shopProduct.itemCode"></el-input>
                <el-button
                    :disabled="stateDisabled"
                    type="primary"
                    @click="genProductNum"
                    size="small"
                    style="margin-left: 10px; width: 60px"
                    >生成</el-button
                >
            </el-form-item>
<!--            <el-form-item label="商品价格" prop="shopPrice">-->
<!--                <el-input :disabled="stateDisabled" style="width: 200px" size="small" v-model="shopProduct.shopPrice"></el-input>-->
<!--            </el-form-item>-->
<!--            <el-form-item label="市场价格" prop="marketPrice">-->
<!--                <el-input :disabled="stateDisabled" style="width: 200px" size="small" v-model="shopProduct.marketPrice"></el-input>-->
<!--            </el-form-item>-->
<!--            <el-form-item label="商品分类" prop="categoryId">-->
<!--                <el-select-->
<!--                    :disabled="stateDisabled"-->
<!--                    style="width: 200px"-->
<!--                    v-model="shopProduct.categoryId"-->
<!--                    placeholder="请选择"-->
<!--                    clearable-->
<!--                    size="small"-->
<!--                >-->
<!--                    <el-tree node-key="id" :default-expanded-keys="expands" :data="shopProductCategoryList" :props="treeProps">-->
<!--                        <div class="custom-tree-node flex items-center" slot-scope="{ node, data }">-->
<!--                            <el-option :label="node.label" :value="data.id"> </el-option>-->
<!--                        </div>-->
<!--                    </el-tree>-->
<!--                </el-select>-->
<!--            </el-form-item>-->


            <!--分类选择-->
            <el-form-item label="分类选择" prop="categoryId" v-for="(item,index) in categoryList" :key="index">
                <el-select :disabled="stateDisabled" size="small" style="width: 200px" v-model="categoryId[index]">
                    <el-option v-for="(itemSon,indexSon) in item" :key="indexSon" :label="itemSon.node.name" :value="itemSon.node.id"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="商品品牌" prop="brandId">
                <GridSelect
                    style="width: 200px"
                    title="选择品牌"
                    labelName="fullName"
                    labelValue="id"
                    :value="shopProduct.brandId"
                    :limit="1"
                    :stateDisabled="stateDisabled"
                    size="small"
                    placeholder="请选择品牌"
                    @getValue="getValue"
                    :columns="[
                        {
                            prop: 'logo',
                            label: '品牌LoGo',
                            img: 'img'
                        },
                        {
                            prop: 'fullName',
                            label: '品牌名称',
                            img: 'img'
                        }
                    ]"
                    :searchs="[
                        {
                            prop: 'brandName',
                            label: '品牌名称'
                        }
                    ]"
                    :dataListUrl="`/huicaiyun/huicaiyunproduct/getBrandList?categoryId=${categoryId[categoryId.length-1]}`"
                    entityBeanName="brandName"
                    :queryEntityUrl="`/huicaiyun/huicaiyunproduct/getBrandList?categoryId=${categoryId[categoryId.length-1]}`"
                >
                </GridSelect>
            </el-form-item>

<!--            <el-form-item label="商品类型" prop="productType">-->
<!--                <el-select size="small" style="width: 200px" v-model="shopProduct.productType" :disabled="stateDisabled">-->
<!--                    <el-option v-for="item of productType" :key="item.key" :label="item.value" :value="item.key"> </el-option>-->
<!--                </el-select>-->
<!--            </el-form-item>-->
<!--            <el-form-item label="所需积分" v-if="shopProduct.productType == 2">-->
<!--                <el-input style="width: 200px" size="small" v-model="shopProduct.productScore" :disabled="stateDisabled"></el-input>-->
<!--            </el-form-item>-->


<!--            <el-form-item label="库存数量" prop="stockSize">-->
<!--                <el-input :disabled="stateDisabled" style="width: 200px" size="small" v-model="shopProduct.stockSize"></el-input>-->
<!--            </el-form-item>-->
<!--            <el-form-item label="已售数量" prop="saleSize">-->
<!--                <el-input :disabled="stateDisabled" style="width: 200px" size="small" v-model="shopProduct.saleSize"></el-input>-->
<!--            </el-form-item>-->

<!--            <el-form-item label="限购数量" prop="buyLimit">-->
<!--                <el-input-->
<!--                    :disabled="stateDisabled"-->
<!--                    style="width: 200px"-->
<!--                    size="small"-->
<!--                    placeholder="请填写限购数量，0不限购"-->
<!--                    v-model="shopProduct.buyLimit"-->
<!--                ></el-input>-->
<!--            </el-form-item>-->
<!--            <el-form-item label="商品排序" prop="sort">-->
<!--                <el-input-number-->
<!--                    style="width: 200px"-->
<!--                    v-model="shopProduct.sort"-->
<!--                    size="small"-->
<!--                    label=""-->
<!--                    :disabled="stateDisabled"-->
<!--                    :min="1"-->
<!--                    :max="100"-->
<!--                    :step="10"-->
<!--                    :controls="true"-->
<!--                    controls-position="both"-->
<!--                >-->
<!--                </el-input-number>-->
<!--            </el-form-item>-->
<!--            <el-form-item label="是否精选" prop="isSelected">-->
<!--                <el-select :disabled="stateDisabled" size="small" style="width: 200px" v-model="shopProduct.isSelected">-->
<!--                    <el-option v-for="isDelicate in isShowList" :key="isDelicate.key" :label="isDelicate.value" :value="isDelicate.key">-->
<!--                    </el-option>-->
<!--                </el-select>-->
<!--            </el-form-item>-->
<!--            <el-form-item label="是否推荐" prop="isRecommend">-->
<!--                <el-select :disabled="stateDisabled" size="small" style="width: 200px" v-model="shopProduct.isRecommend">-->
<!--                    <el-option v-for="isDelicate in isShowList" :key="isDelicate.key" :label="isDelicate.value" :value="isDelicate.key">-->
<!--                    </el-option>-->
<!--                </el-select>-->
<!--            </el-form-item>-->
<!--            <el-form-item label="是否上架" prop="isShow">-->
<!--                <el-select :disabled="stateDisabled" size="small" style="width: 200px" v-model="shopProduct.isShow">-->
<!--                    <el-option v-for="isShow in isShowList" :key="isShow.key" :label="isShow.value" :value="isShow.key"> </el-option>-->
<!--                </el-select>-->
<!--            </el-form-item>-->
<!--            <el-form-item label="是否包邮" prop="isFreightFree">-->
<!--                <el-select :disabled="stateDisabled" size="small" style="width: 200px" v-model="shopProduct.isFreightFree">-->
<!--                    <el-option-->
<!--                        v-for="isFreightFree in isShowList"-->
<!--                        :key="isFreightFree.key"-->
<!--                        :label="isFreightFree.value"-->
<!--                        :value="isFreightFree.key"-->
<!--                    >-->
<!--                    </el-option>-->
<!--                </el-select>-->
<!--            </el-form-item>-->

<!--            <el-form-item label="运费金额" prop="freightPrice" v-if="shopProduct.isFreightFree != 1">-->
<!--                <el-input :disabled="stateDisabled" style="width: 200px" size="small" v-model="shopProduct.freightPrice"></el-input>-->
<!--            </el-form-item>-->

            <el-form-item label="商品主图" prop="mainImage">
                <el-upload
                    :disabled="stateDisabled"
                    style="width: 200px"
                    class="avatar-uploader"
                    action=""
                    :show-file-list="false"
                    :http-request="uploadAvatar"
                >
                    <img v-if="shopProduct.mainImage" :src="shopProduct.mainImage" class="avatar" size="small" referrerpolicy="no-referrer"/>
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
            </el-form-item>


        </el-form>
    </div>
</template>
<script>
import eventBus from '../../api/eventBus';
import GridSelect from '../huicaiyun/brand.vue';
import { get, post, deleteFun, upload } from '@/utils/request.js';
export default {

    props: {
        pubVue: {
            type: Object
        }
    },
    components: {
        GridSelect
    },
    data() {
        return {
            categoryList:[],// 分类列表
            categoryId:[],// 选择的分类id
            categoryName:[],// 选择的分类name
            obj:[],// 深拷贝，解决深度监听新值旧值一样问题




            productType:[],
            shopProduct: {
                id: '', //Id
                productName: '', //商品名称
                itemCode: '', //商品货号
                mainImage: '', //图片
                categoryId: '', //产品分组id
                brandId: '', //品牌Id
            },

            rules: {
                productName: [{ required: true, message: '商品名称不能为空', trigger: 'blur' }],
                itemCode: [{ required: true, message: '商品货号不能为空', trigger: 'blur' }],
                mainImage: [{ required: true, message: '商品主图不能为空', trigger: 'blur' }],
                categoryId: [{ required: true, message: '商品分类不能为空', trigger: 'blur' }],
            },

            shopProductCategoryList: [],
            treeProps: {
                children: 'children',
                label: 'categoryName'
            },
            isShowList: [], //是否上架
            stateDisabled: false,
            expands: []
        };
    },
    watch:{
        /*
        * 动态分类设置:
        *       使用 二维数组 categoryList 存获取到的每级list
        *       使用 数组 categoryId 存选择的id
        *
        *       请求方法 getCategoryList(id,index)
        *       形参id:传入当前等级id，查找下一级
        *       形参index:传入一维 categoryList 存放的索引号
        *
        *       这时候拿到了1级分类 categoryList[0]
        *       在 <el-form-item> 里循环一维 categoryList 这里如果有其他级也会循环出
        *       <el-select> 里绑定的值是存放id的数组 categoryId 存放的索引号取 categoryList 的 index
        *       <el-option> 里循环的是二维的 categoryList
        *
        *       监听存放id的 categoryId 数组，发生变化时判断新值和旧值的长度，新值比旧值长说明是新选择的一列
        *       如果旧值等于或小于新值说明是修改已经选择的级别，通过比较新旧值来找到修改的哪一级，多余级的数据截取掉
        *       直接使用监听的 newValue oldValue 会出现内存地址一样无法知道哪级改了，用 obj 拷贝一下
        *       最后拿数组 categoryId 里末尾的id去数组 categoryList 相同索引里二维里找相同的id
        *       找到之后去看这个分类的对象是不是还有下一级，有继续掉 getCategoryList(id,index) 请求下一级数据
        *
        *
        * */
        categoryId:{
            handler(newValue){
                // 判断是新选择的，还是在已经有的上面更改
                if(newValue.length > this.obj.length){


                }else {
                    for (let i = 0; i < newValue.length; i++) {
                        if((newValue[i] != this.obj[i]) && (newValue.length != 1)){
                            this.categoryList = this.categoryList.slice(0,i+1)
                            this.categoryId = this.categoryId.slice(0,i+1)
                            this.categoryName = this.categoryName.slice(0,i+1)
                        }
                    }
                }
                try {
                    // 查找对应id的分类有没有下级，如果有继续请求下一级数据
                    for (let i = 0; i < this.categoryList[newValue.length-1].length; i++) {
                        if(this.categoryList[newValue.length-1][i].node.id == newValue[newValue.length-1]){

                            // 把各级分类name存上
                            this.categoryName[newValue.length-1] = this.categoryList[newValue.length-1][i].node.name
                            // 如果有下一级继续请求

                            if(this.categoryList[newValue.length-1][i].node.hasChildren){
                                this.getCategoryList(newValue[newValue.length-1],newValue.length)
                            }else {
                                // 没有下一级了  把选择的每级id拼成字符串，用|分割
                                this.shopProduct.categoryId = this.categoryId.join('|')

                                this.$emit('change',this.shopProduct.categoryId)
                            }
                        }
                    }
                } catch {
                    console.error('null 没有 length ')
                }

                this.obj = JSON.parse(JSON.stringify(newValue)) // 深拷贝
            },
            immediate: true,
            deep:true
        },
        shopProduct(nv,ov){
            /*
            *       点修改 get 到这个商品信息后触发这监听方法
            *       先把 get 到的分类 id 从字符串转成数组
            *       然后拿每级分类 id 去请求每级分类
            *
            * */
            return
            try {
                const categoryIdList = this.shopProduct.categoryId.split('|')
                for (let i = 0; i < categoryIdList.length; i++) {
                    if( i != categoryIdList.length - 1){
                        this.getCategoryList(+categoryIdList[i],i+1)
                    }
                    this.categoryId[i] = +categoryIdList[i]
                }
            } catch {
                console.error('null 不能使用 split()');
            }

        },
    },
    created() {
        eventBus.$on('shopProduct', (data, state) => {
            // 不改变原组件的值
            this.shopProduct = { ...this.shopProduct, ...data };
            // for (let item of this.shopProduct.skuValueList) {
            //     if (item.stock) {
            //         this.shopProduct.stockSize += item.stock;
            //     }
            // }
            this.$forceUpdate();
            if (state == 'check') {
                this.stateDisabled = true;
            } else {
                this.stateDisabled = false;
            }
        });
    },

    mounted() {
        this.getClassification();
        this.getIsShowList();
        this.getProductType();
		this.getCategoryList();
    },
    methods: {
        //获取分类
        getCategoryList(id = 0,index = 0){
			get(`/huicaiyun/huicaiyunproduct/getCategoryList`,{
                categoryId:id,
                depth:2
            }).then((res) => {
                if(res.success){
                    this.categoryList[index] = res.list
                }
                this.$forceUpdate() // 更新DOM

			});
		},
        //是否上架
        getIsShowList() {
            get(`/mpp/utils/getEnum`, { enumType: `yes_no` }).then((res) => {
                if (res.success) {
                    this.isShowList = res.enumList;
                }
            });
        },
        getClassification() {
            get(`/shop/productcategory/findAllAsTree`).then((res) => {
                if (res.success && res.code == 200) {
                    this.shopProductCategoryList = res.treeData;
                    res.treeData.forEach((element) => {
                        this.expands.push(element.id);
                    });
                }
            });
        },
        //生成货号，货号不能为空
        genProductNum() {
            let dateTime;
            let yy = new Date().getFullYear();
            let mm = new Date().getMonth() + 1;
            let dd = new Date().getDate();
            let hh = new Date().getHours();
            let mf = new Date().getMinutes() < 10 ? '0' + new Date().getMinutes() : new Date().getMinutes();
            let ss = new Date().getSeconds() < 10 ? '0' + new Date().getSeconds() : new Date().getSeconds();
            dateTime = yy + '' + mm + '' + dd + '' + hh + '' + mf + '' + ss;
            this.shopProduct.productNumber = dateTime;
        },
        //上传缩略图
        uploadAvatar(params) {
            const file = params.file;
            let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
            if (!types.includes(file.type)) {
                this.$message.error('图片类型错误!');
            }
            const formData = new FormData();
            formData.append('file', file);
            upload(`/mpp/image/upload`, formData).then((res) => {
                if (res.success) {
                    this.shopProduct.mainImage = res.url;
                }
            });
        },
        validateForm() {
            let flag = true;
            this.$refs.shopProductForm.validate((valid) => {
                if (valid) {
                    flag = true;
                } else {
                    console.log('error submit!!');
                    flag = false;
                }
            });
            return flag;
        },

        // ClassificationChange() {
        //     let obj = {
        //         categoryId: this.shopProduct.categoryId,
        //         brandId: this.shopProduct.brandId
        //     };

        //     eventBus.$emit('attribute', obj);
        //     eventBus.$emit('speci', obj);
        // },

        // 品牌组件传过来的品牌id和品牌name
        getValue(value,name) {
            console.log('value,name',value,name)

            this.shopProductCategoryList.brandId = value;
            this.shopProduct.brandId = value;
            this.shopProduct.brandName = name;

            this.$emit('getSpuList', value,name);
            // this.ClassificationChange();
        },
        getProductType(){
            get("/mpp/utils/getEnum",{enumType:"product_type"}).then((res)=>{
                if(res.success && res.code == 200){
                    this.productType = res.enumList
                }
            })
        },
        clear(){
            this.categoryList = [];
            this.categoryId = [];
            this.categoryName = [];
            this.obj = [];
            this.getCategoryList();
        }
    }
};
</script>
<style lang="scss" scoped>
.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 200px !important;
    height: 200px !important;
    line-height: 200px;
    text-align: center;
}
.avatar {
    width: 200px;
    height: 200px;
    display: block;
}
.avatarWide {
    width: 200px;
    height: 120px;
}
::v-deep .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 200px;
    height: 200px;
}

.el-popper el-cascader__dropdown{
	top: 0;
}



element.style{

}

.pc-sel-area-cascader {
    .el-cascader-node.in-active-path,
    .el-cascader-node.is-active,
    .el-cascader-node.is-selectable.in-checked-path {
        color: #4e5ef1;
    }
}

.cascader-popper {
    //.el-scrollbar{
    //max-width: 100px !important;
    //overflow: scroll !important;
    //}

    .el-scrollbar{
        top: 4200px;
    }


}
.el-form-item__label{
    width: 90px;
}

</style>
